import { PageLocatorMap } from '../types/PageLocatorMap';

export const notFoundPage = {
  header: {
    root: 'not-found.header.root',
  },
  main: {
    h1: 'not-found.main.heading1',
    h2: 'not-found.main.heading2',
    returnHomeButton: 'not-found.main.return-home-button',
    root: 'not-found.main.root',
  },
} as const satisfies PageLocatorMap;
